<template>
<div>
  <b-modal id="schlocation" centered :hide-footer="true" :hide-header="true"> 
          <!-- <Rating/> -->
        <span>
        <l-map
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                @update:zoom="zoomUpdated"
                @update:bounds="boundsUpdated"
                style=" height: 350px; width: 100%;"
              >
                <l-tile-layer :url="url" />
                <l-control-attribution position="topright" :prefix="this.attributionPrefix" />
                <l-control-zoom position="bottomright"></l-control-zoom>
                <l-marker :lat-lng.sync="center" :draggable="true">
                  <LIcon
                    :icon-size="[34, 40]"
                    :icon-anchor="[17, 40]"
                    :popupAnchor="[0, -32]"
                    :icon-url="require('@/assets/map-marker.svg')"

                  />
                  <l-popup :lat-lng="center">
                    <div class="text-center">
                      <h6
                        class="m-0"
                      >Selected Location</h6>
                      <small>{{center}}</small>
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>
        </span>
    </b-modal>

</div>
</template>

<script>
import http from '@/network/Base.js' 
// import { CoolSelect } from "vue-cool-select";
// import Countries from "@/assets/countries.json";
import { latLng } from "leaflet";
import {mapState} from 'vuex'
import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlZoom,
  LFeatureGroup,
  LPopup,
  LIcon,
    LControlAttribution

} from "vue2-leaflet";

   
export default {
   components: {
     LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlZoom,
  LFeatureGroup,
  LPopup,
  LIcon,
    LControlAttribution

  },
  data: () => ({
    loading: false,
    banks:[],
      saveAble: true,
      sr_file: '',
      sr_filename: '',
      center: { lat: 0, lng: 0 },
      // provider.sz_kycfile
      // provider.sz_ghpostgps
    provider: {
        sz_orgname:"",
        sz_address:"",
        sz_providerid:"",
        sz_contactname:"",
        sz_contactphoneno:"",
        sz_contactemail:"",
        szwalletnumber:"",
        sz_bank: "",
        sz_branchid:"",
        sz_acctno:'',
        sz_geolat:'',
        sz_geolong: '',
        sz_kycfile:'',
        sz_ghpostgps:'',
        sz_alias: ''
    },
    ban: '',
    zoom: 16,
     
      // center: { lat: 5.7142836, lng: 0.0746767 },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attributionPrefix: "Please drag marker to your preferred location Location",
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false
      },
      bounds: null,
    szbank:'',
    branches: []
  }),
  methods: {
    close(){
      this.$router.push('/')
    },
    zoomUpdated (zoom) {
      this.zoom = zoom;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getBanks(){
        http().get("/aGetBanks/")
           .then(({data}) => {
             this.banks = data
            })
            .catch(err => {
                this.$snotify.error('Could not get the list of banks')
            })
    },
    handleFileUpload(){
       let f = this.$refs.uploadFile.files[0]
       // console.log(f)
      const reader = new FileReader();

  reader.onload = (function(theFile) {
    return function(e) {
      var binaryData = e.target.result;
      //Converting Binary Data to base 64
      let base64String = window.btoa(binaryData);
      //showing file converted to base64
      document.getElementById('base64').value = base64String;
      // alert('File converted to base64 successfuly!\nCheck in Textarea');
    };
  })(f)
  // Read in the image file as a data URL.
  reader.readAsBinaryString(f);
  // // toBase64()
      this.provider.sz_kycfile = this.$refs.uploadFile.files[0].name

      // console.log(this.sr_file)
      this.saveAble = true
      this.$snotify.info('The file "' + this.provider.sz_kycfile +  '" has been selected. Please Upload', {
        timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            position: "centerTop"
        })
      },
    submit(){
      this.banks.forEach(el => {
              if(el.szbankid == this.provider.sz_bank){
                this.provider.sz_bank = el.szbankname
                this.szbank = el.szbankname
                // console.log(this.szbank)
              } else {
                this.szbank = ''
              }
             })
      // console.log(this.provider)
      /*sz_geolat:'',
        sz_geolong: '',*/

      this.provider.sz_providerid = this.providerId
      this.provider.sz_geolat = this.center.lat
      this.provider.sz_geolong = this.center.lng
      this.$Progress.start()
        this.loading = true
        http().post("/AddProviderSchools/", this.provider)
           .then(({data}) => {
             // console.log(data.message.response)
                this.$snotify.success(data.message.reason)
                if(data.success == 'true')
                {
                    this.close();
                }

            })
            .catch(err => {
                this.$snotify.error('Could not get the list of schools')
                this.$Progress.finish()
            })
            .finally(() => {
                this.loading = false
                this.$Progress.finish()

            })
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(
        this.showPosition,
        this.showError
      );
    },

    showPosition(position) {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      //    this.getCity(this.center, this.getResponse)
      this.center = this.center;
    },
    getBraches(){
this.$Progress.start()
        http().post("/aGetBankBranches/", {szbankid: this.provider.sz_bank})
           .then(({data}) => {
             this.branches = data
             
            })
            .catch(err => {
                this.$snotify.error('Could not get the list of branches')
            })
    },
    getBranch(value){
      this.szbank = value.target.value
      this.provider.sz_bank = value.target.value
      this.getBraches()
      
    }
  },
  created(){
    this.getBanks()
    this.getLocation();
  },
  computed: {
       ...mapState({
           providerId: (state) => state.provider.provider_id
       }),
   }

}
</script>
<style scoped>
label{
    font-weight: bold;
}
</style>
